import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FmRecordings extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public createdTimestamp: string;

  @Expose()
  public updatedTimestamp: string;

  @Expose()
  public sid: string;

  @Expose()
  public status: string;

  @Expose()
  public duration: number;

  @Expose()
  public format: string;

  @Expose()
  public bitrate: number;

  @Expose()
  public failedOperation: null;

  @Expose()
  public mediaUrl: null;

  @Expose()
  public size: number;

  @Expose()
  public type: string;

  @Expose()
  public isDefault: true;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
